import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const orderScanService = {};

orderScanService.removeScan = ({ id }) => {
  return fetchV2({
    url: `${env.API_MSP}/order-scans/${id}/remove-scan`,
    method: "delete",
  });
};

orderScanService.start = ({ isSendOrder, ...extra }) => {
  return fetchV2({
    url: `${env.API_MSP}/scans/start`,
    method: "post",
    data: {
      type: isSendOrder ? "scan_send" : "scan_receive",
      ...extra,
    },
  });
};

orderScanService.startStatus = ({ isSendOrder, ...extra }) => {
  return fetchV2({
    url: `${env.API_MSP}/scans/start-status`,
    method: "get",
    params: {
      type: isSendOrder ? "scan_send" : "scan_receive",
      ...extra,
    },
  });
};

orderScanService.end = ({ scan_id }) => {
  return fetchV2({
    url: `${env.API_MSP}/scans/${scan_id}/end`,
    method: "post",
  });
};

orderScanService.receivce = ({
  barcode,
  scan_id,
  isSendOrder,
  transport_id,
  allowed_group_to_transfer,
  from_hub,
  to_hub,
  manager_hub_id,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/order-scans/${scan_id}/${
      isSendOrder ? "send" : "receive"
    }`,
    method: "post",
    data: {
      barcode,
      transport_id: transport_id || null,
      allowed_group_to_transfer,
      from_hub,
      to_hub,
      manager_hub_id: manager_hub_id,
    },
  });
};

orderScanService.info = ({ barcode }) => {
  return fetchV2({
    url: `${env.API_MSP}/order-scans/info`,
    method: "post",
    data: {
      barcode,
    },
  });
};

orderScanService.addScan = ({ code, isSendOrder }) => {
  return fetchV2({
    url: `${env.API_MSP}/order-scans/add-scan`,
    method: "post",
    data: {
      code: code,
      type: isSendOrder ? "scan_send" : "scan_receive",
    },
  });
};

orderScanService.uploadFile = ({ idHistoryScan, listIdResource }) => {
  return fetchV2({
    url: `${env.API_MSP}/order-scans/${idHistoryScan}/upload-file`,
    method: "post",
    data: {
      // type: "scan_receive",
      files: listIdResource,
    },
  });
};

orderScanService.removeFile = ({ listIdResource }) => {
  return fetchV2({
    url: `${env.API_MSP}/order-scans/remove-file`,
    method: "post",
    data: {
      files: listIdResource,
    },
  });
};

// listOrderScan
orderScanService.listOrderScan = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/order-scans`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker,scanner,scanId",
      fields: params.fields || defaultFields.join(","),
      tracking_key: params.tracking_key,
      scan_id: params.scan_id,
      order_status: params.order_status,
    },
  });
};

// List OrderScanStatus
orderScanService.listOrderScanStatus = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/order-scans/status`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// ListOrderScanActionType
orderScanService.listOrderScanActionType = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/order-scans/action-type`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// listPhaseOrderScan
orderScanService.listPhaseOrderScan = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/scans`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker,finisher,starter,total",
      fields: params.fields || defaultFields.join(","),
      tracking_key: params.tracking_key,
    },
  });
};

// detailPhaseOrderScan
orderScanService.detailPhaseOrderScan = ({ id }) => {
  return fetchV2({
    url: `${env.API_MSP}/scans/${id}`,
    method: "get",
    params: {
      expand: "finisher,starter,action_type,status,total,newSendOrderScanTotal",
      fields:
        "total,action_type,newSendOrderScanTotal,name,status,start_date,end_date,starter,finisher",
    },
  });
};

// listPhaseOrderScanStatus
orderScanService.listPhaseOrderScanStatus = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/scans/status`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// listPhaseOrderScanActionType
orderScanService.listPhaseOrderScanActionType = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/scans/action-type`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// detailPhaseOrderScan
orderScanService.dashboardPhaseOrderScan = ({ id }) => {
  return fetchV2({
    url: `${env.API_MSP}/scans/${id}/dashboard`,
    method: "get",
  });
};

orderScanService.checkOrderAddToOrderTransfer = ({
  orderCode,
  orderTransferId,
  orderType,
  from_hub,
  to_hub,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/order-transfers/order-transfer-info`,
    method: "post",
    data: {
      order_code: orderCode,
      ref_code: orderCode,
      from_hub: from_hub,
      to_hub: to_hub,
      parent_id: orderTransferId,
      type: orderType,
    },
  });
};

export default orderScanService;
